import type { GQLPageMeta } from './generated/page-meta'

export function usePageMeta(meta: GQLPageMeta, structuredData?: unknown) {
  useHead({
    htmlAttrs: meta.language ? { lang: meta.language } : undefined,
    title: meta.title,
    meta: [
      { key: 'description', name: 'description', content: meta.description },
      { key: 'robots', name: 'robots', content: meta.noIndex ? 'noindex' : 'index' },
      {
        key: 'og:title',
        name: 'og:title',
        content: meta.relatedContent?.title ?? meta.title,
      },
      {
        key: 'og:description',
        name: 'og:description',
        content: meta.relatedContent?.description ?? meta.description,
      },
      {
        key: 'og:image',
        name: 'og:image',
        content:
          meta.relatedContent?.image?.url ??
          'https://cdn.sanity.io/images/whc4dqyy/production/fb916fe3283647fb75f7fc8d63fa425ee3a3b629-1200x630.png',
      },
      { key: 'fo-verify', name: 'fo-verify', content: '82b61d45-4fcd-49e0-83e1-972334598aff' },
    ].filter((o) => o.content), // exclude empty meta
    link: [
      ...meta.alternateLanguages.map(({ language, slug }) => ({
        key: `alternate-${language}`,
        rel: 'alternate',
        href: slug,
        hreflang: language,
      })),
      {
        key: 'canonical',
        rel: 'canonical',
        href:
          meta.alternateLanguages.find(({ language }) => language === meta.language)?.slug ??
          undefined,
      },
      {
        key: 'alternate-x-default',
        rel: 'alternate',
        href: meta.alternateLanguages.find(({ language }) => language === 'en')?.slug ?? undefined,
        hreflang: 'x-default',
      },
    ].filter((tag) => tag.href),
    script: structuredData
      ? [
          {
            key: 'structured-data',
            type: 'application/ld+json',
            innerHTML: JSON.stringify(structuredData),
          },
        ]
      : [],
  })
}
